import { render } from "./ModifiedEditor.vue?vue&type=template&id=c4b0341c"
import script from "./ModifiedEditor.vue?vue&type=script&lang=js"
export * from "./ModifiedEditor.vue?vue&type=script&lang=js"

import "./ModifiedEditor.vue?vue&type=style&index=0&id=c4b0341c&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__